import { ProgressSpinner } from "primereact/progressspinner";
import styled from "styled-components";
import { theme } from "styles/theme";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  min-height: 40vh;
  width: 100%;
  color: ${theme.colors.textSecondary};
`;

interface LoadingScreenProps {
  message?: string;
  fullPage?: boolean;
}

export function LoadingScreen({
  message = "Loading...",
  fullPage = false,
}: LoadingScreenProps) {
  return (
    <Wrapper
      role="status"
      aria-live="polite"
      aria-busy="true"
      style={fullPage ? { minHeight: "100vh" } : undefined}
    >
      <ProgressSpinner
        style={{ width: "50px", height: "50px" }}
        strokeWidth="4"
        aria-hidden
      />
      <p>{message}</p>
    </Wrapper>
  );
}
